import { render, staticRenderFns } from "./Founder.vue?vue&type=template&id=aa8e457c&scoped=true&"
import script from "./Founder.vue?vue&type=script&lang=js&"
export * from "./Founder.vue?vue&type=script&lang=js&"
import style0 from "./Founder.vue?vue&type=style&index=0&id=aa8e457c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8e457c",
  null
  
)

export default component.exports